module.exports = __webpack_public_path__ + "media/images/reportimages/low-tech-5093d69535d13d01e5fabac310fbe774.png";